import api from './api';
import type { WineListFormat } from '../types/venue';

const base = (venueId: string, wineListId: string) =>
  `/admin/venue/${venueId}/wine-list/${wineListId}/formats`;

export interface CreateFormatPayload {
  name: string;
  volumeMl: number;
  position?: number;
}

export type UpdateFormatPayload = Partial<CreateFormatPayload> & { active?: boolean };

const wineListFormatService = {
  /** List active formats for a wine list, ordered by position. */
  getFormats: async (venueId: string, wineListId: string): Promise<WineListFormat[]> => {
    const response = await api.get(base(venueId, wineListId));
    return response.data;
  },

  /** Create a new format. */
  createFormat: async (
    venueId: string,
    wineListId: string,
    data: CreateFormatPayload,
  ): Promise<WineListFormat> => {
    const response = await api.post(base(venueId, wineListId), data);
    return response.data;
  },

  /** Partial update of a format (name, volumeMl, position, or active). */
  updateFormat: async (
    venueId: string,
    wineListId: string,
    formatId: string,
    data: UpdateFormatPayload,
  ): Promise<WineListFormat> => {
    const response = await api.patch(`${base(venueId, wineListId)}/${formatId}`, data);
    return response.data;
  },

  /** Soft-delete a format. Existing per-item pricings remain but stop appearing in the render. */
  deleteFormat: async (
    venueId: string,
    wineListId: string,
    formatId: string,
  ): Promise<void> => {
    await api.delete(`${base(venueId, wineListId)}/${formatId}`);
  },
};

export default wineListFormatService;
